import { makeAutoObservable } from 'mobx'
import {
  type IDropdownItem,
  PhoneInputStore,
  EnumDropdownItemVariant,
  CountryEnum,
} from 'shared/ui'
import { getTimezonesList } from 'shared/lib'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { type IUser } from 'entities/Users/model/types'
export class MemberProfileStore {
  private _firstName = ''
  private _firstNameError = ''
  private _lastName = ''
  private _lastNameError = ''
  private _number = ''
  private _email = ''
  private _timezone = ''
  private _timezoneError = ''
  private _phoneInputStore
  private _limitFirstNameReached = false
  private _limitLastNameReached = false

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)

    this._phoneInputStore = new PhoneInputStore()
  }

  get phoneInputStore() {
    return this._phoneInputStore
  }

  get firstName() {
    return this._firstName
  }

  get firstNameError() {
    return this._firstNameError
  }

  get lastName() {
    return this._lastName
  }

  get lastNameError() {
    return this._lastNameError
  }

  get number() {
    return this._number
  }

  get timezone() {
    return this._timezone
  }

  get timezoneError() {
    return this._timezoneError
  }

  get email() {
    return this._email
  }

  get timezoneItems(): IDropdownItem[] {
    return getTimezonesList().map((tz) => ({
      id: tz.value,
      label: tz.label,
      value: tz.value,
      group: tz.group,
      variant: EnumDropdownItemVariant.CheckedRight,
    }))
  }

  get limitFirstNameReached() {
    return this._limitFirstNameReached
  }

  setLimitFirstNameReached = (status: boolean) => {
    this._limitFirstNameReached = status
  }

  get limitLastNameReached() {
    return this._limitLastNameReached
  }

  setLimitLastNameReached = (status: boolean) => {
    this._limitLastNameReached = status
  }

  init = (member: IUser) => {
    this._firstName = member.first_name
    this._lastName = member.last_name
    this._timezone = member.timezone || ''
    this._email = member.email
    this._number = member.user_number || ''

    let number = member.user_number
    if (number) {
      if (number.startsWith('+44')) {
        number = number.slice(3)
        const countryItem = this._phoneInputStore.countries.find(
          (item) => item.id === CountryEnum.GB
        )
        if (countryItem) this._phoneInputStore.setCountry(countryItem)
      } else if (number.startsWith('+1')) {
        number = number.slice(2)
        const countryItem = this._phoneInputStore.countries.find(
          (item) => item.id === CountryEnum.US
        )
        if (countryItem) this._phoneInputStore.setCountry(countryItem)
      }

      this._phoneInputStore.setNumber(number)
    }
  }

  setTimezone = (value: string) => {
    this._timezone = value
    if (this._timezoneError) this._timezoneError = ''
  }

  setEmail = (value: string) => {
    this._email = value
  }

  setNumber = (value: string) => {
    this._number = value
  }

  setFirstName = (value: string) => {
    this._firstName = value
    if (this._firstNameError) this._firstNameError = ''
  }

  setLastName = (value: string) => {
    this._lastName = value
    if (this._lastNameError) this._lastNameError = ''
  }

  reset = () => {
    this._firstName = ''
    this._lastName = ''
    this._timezone = ''
  }
}
